import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import withTracker from "./withTracker";

import Home from './components/index/Home';
import NotFound from "./components/error/NotFound";

export default () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={withTracker(Home)} />
        <Route component={withTracker(NotFound)} />
      </Switch>
    </Router>
  );
}



// WEBPACK FOOTER //
// ./src/Routes.js